import { html } from "@microsoft/fast-element";

export default html`
  <site-image>
    <img src=${x => x.imgSrc} alt=${x => x.imgAlt} />
  </site-image>
  <div part="body">
    <slot></slot>
  </div>
`